import { CpClaimResponseInterface } from '../../../interfaces/response/claim/cp-claim-response-interface';
import { CpClaimModel } from '../../dto/claim/cp-claim-model';
import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';

export class CpClaimResponseModel implements CpClaimResponseInterface {
  Claims: CpClaimModel[] = new Array<CpClaimModel>();
  PaginationResult: PaginationModel = new PaginationModel();

  constructor(init?: Partial<CpClaimResponseModel>) {
    Object.assign(this, init);
  }
}
